var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isBusy)?_c('div',[_c('category-tree-item',{staticClass:"item",attrs:{"category":_vm.categoriesTree}})],1):_c('div',{staticClass:"text-center col-12 col-xl-10",staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',{staticStyle:{"margin-left":"10px"}},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }